export default __webpack_public_path__ + "static/media/PostgreSQL.3f52b225.png";